module.exports = __webpack_public_path__ + "static/image-demo-c115ed60ac75437da5688495ba2c6f22.jpg";